import {
    CHECK_ALREADY_LIKED,
    GET_LIKES,
    GET_LIKES_FULFILLED,
    GET_LIKES_REJECTED,
    GET_SHARE_SERVICE_URL,
    GET_SHARE_SERVICE_URL_SUCCESS,
    LIKE_SHARE,
    LIKE_SHARE_SUCCESS,
    UNLIKE_SHARE,
    UNLIKE_SHARE_SUCCESS
} from "../constants";

const initialState = {
    loadingGettingUserDetails: true,
    userId: null,
    likeMapping: {
        likesCount: 0,
        users: []
    },
    recievedLikes: false,
    checkedUser: false,
    likedAlready: false,
    liked: true,
    comments: [],
    shareServiceResponse: null
};

function shareReducer(state = initialState, action) {
    switch (action.type) {
        case GET_LIKES:
            return {
                ...state,
                recievedLikes: false,
                liked: false
            }

        case GET_LIKES_FULFILLED:
            let likeMapping = state.likeMapping;
            const {data} = action.payload;
            if (action.payload.status !== 204) {
                likeMapping = data;
            } else {
                likeMapping = {
                    likesCount: 0,
                    users: []
                }
            }
            return {
                ...state,
                likeMapping,
                recievedLikes: true,
                liked: false
            }

        case GET_LIKES_REJECTED:
            return {
                ...state
            }

        case CHECK_ALREADY_LIKED:
            return {
                ...state,
                likedAlready: action.payload,
                checkedUser: true
            }

        case LIKE_SHARE:
            return {
                ...state
            }

        case LIKE_SHARE_SUCCESS:
            return {
                ...state,
                liked: true
            }

        case UNLIKE_SHARE:
            return {
                ...state
            }

        case UNLIKE_SHARE_SUCCESS:
            return {
                ...state,
                liked: true
            }

        case GET_SHARE_SERVICE_URL:
            return {
                ...state
            }

        case GET_SHARE_SERVICE_URL_SUCCESS:

            return {
                ...state,
                shareServiceResponse: action.payload.data
            }

        default:
            return state;
    }
}

export default shareReducer;
  